// Centralized fleet-related constants

export const VEHICLE_ORDER = [
	'Executive Sedan',
	'Luxury SUV',
	'Stretch Limousine',
	'Sprinter Van',
	'Coach Bus'
];

/** Space-free card JPGs — reliable on Hostinger */
export const FLEET_CARD_IMAGES = {
	'Executive Sedan': '/images/fleet/sedan/sedan-card.jpg',
	'Luxury SUV': '/images/fleet/suv/suv-card-v2.jpg',
	'Stretch Limousine': '/images/fleet/limo/limo-card.jpg',
	'Sprinter Van': '/images/fleet/van/van-card.jpg',
	'Coach Bus': '/images/fleet/bus/bus-card.jpg',
	Sedan: '/images/fleet/sedan/sedan-card.jpg',
	SUV: '/images/fleet/suv/suv-card-v2.jpg',
	Limousine: '/images/fleet/limo/limo-card.jpg',
	Limo: '/images/fleet/limo/limo-card.jpg',
	Van: '/images/fleet/van/van-card.jpg',
	Bus: '/images/fleet/bus/bus-card.jpg'
};

/**
 * Resolve a reliable local card image by vehicle name or type (case-insensitive).
 */
export function resolveFleetCardImage(vehicle = {}) {
	const nameKey = (vehicle.name || '').toString().trim().toLowerCase();
	const typeKey = (vehicle.type || '').toString().trim().toLowerCase();

	const byName = {
		'executive sedan': FLEET_CARD_IMAGES['Executive Sedan'],
		'luxury suv': FLEET_CARD_IMAGES['Luxury SUV'],
		'stretch limousine': FLEET_CARD_IMAGES['Stretch Limousine'],
		'sprinter van': FLEET_CARD_IMAGES['Sprinter Van'],
		'coach bus': FLEET_CARD_IMAGES['Coach Bus']
	};

	const byType = {
		sedan: FLEET_CARD_IMAGES.Sedan,
		suv: FLEET_CARD_IMAGES.SUV,
		limousine: FLEET_CARD_IMAGES.Limousine,
		limo: FLEET_CARD_IMAGES.Limo,
		van: FLEET_CARD_IMAGES.Van,
		bus: FLEET_CARD_IMAGES.Bus
	};

	return byName[nameKey] || byType[typeKey] || null;
}

export const FALLBACK_FLEET = [
	{
		name: 'Executive Sedan',
		type: 'Sedan',
		description:
			'Experience elegance and comfort in our premium sedans. Perfect for executive travel or a sophisticated night out, these vehicles offer a quiet, refined atmosphere with all the modern luxuries.',
		image_url: FLEET_CARD_IMAGES['Executive Sedan'],
		image_url_fallback: FLEET_CARD_IMAGES['Executive Sedan'],
		alt: 'Executive black sedan in front of the Lincoln Memorial at night',
		capacity: 'Up to 3',
		luggage: 'Up to 2'
	},
	{
		name: 'Luxury SUV',
		type: 'SUV',
		description:
			'Spacious and versatile, our luxury SUVs provide ample room for passengers and luggage, making them ideal for airport travel, corporate clients, and family outings. Enjoy a smooth ride with top-of-the-line amenities.',
		image_url: FLEET_CARD_IMAGES['Luxury SUV'],
		image_url_fallback: FLEET_CARD_IMAGES['Luxury SUV'],
		alt: 'Luxury black Cadillac Escalade SUV on a city street',
		capacity: 'Up to 6',
		luggage: 'Up to 6'
	},
	{
		name: 'Stretch Limousine',
		type: 'Limousine',
		description:
			"Make a grand entrance with our classic stretch limousine. Synonymous with luxury and celebration, it's the ultimate choice for weddings, proms, and other special occasions that demand a touch of glamour.",
		image_url: FLEET_CARD_IMAGES['Stretch Limousine'],
		image_url_fallback: FLEET_CARD_IMAGES['Stretch Limousine'],
		alt: 'Chrysler 300 stretch limousine on a city street at night with purple lighting',
		capacity: 'Up to 8',
		luggage: 'Up to 4'
	},
	{
		name: 'Sprinter Van',
		type: 'Van',
		description:
			"For larger groups that require both comfort and style, our Sprinter Vans are the perfect solution. With generous space and comfortable seating, they're great for corporate events and group tours.",
		image_url: FLEET_CARD_IMAGES['Sprinter Van'],
		image_url_fallback: FLEET_CARD_IMAGES['Sprinter Van'],
		alt: 'Black Mercedes-Benz Sprinter van on a desert road at sunset',
		capacity: 'Up to 14',
		luggage: 'Up to 10'
	},
	{
		name: 'Coach Bus',
		type: 'Bus',
		description:
			'When you need to transport a large party without compromising on comfort, our coach buses deliver. Ideal for corporate conventions, long-distance group travel, and major events.',
		image_url: FLEET_CARD_IMAGES['Coach Bus'],
		image_url_fallback: FLEET_CARD_IMAGES['Coach Bus'],
		alt: 'Akiblackcar branded coach bus in Washington D.C. at night with the Washington Monument in the background',
		capacity: 'Up to 56',
		luggage: 'Ample'
	}
];

export const FLEET_FALLBACK_IMAGES = { ...FLEET_CARD_IMAGES };
